import { ReactElement } from 'react';
import { Alert, ALERT_DISPLAY_TYPE, ALERT_STYLE_TYPE } from 'b2b-components/core/components/Alert';
import './ContentAlert.scss';

interface Props {
  text: string;
  alertType: ALERT_STYLE_TYPE;
}

export const ContentAlert = ({ text, alertType }: Props): ReactElement => (
  <Alert
    displayType={ALERT_DISPLAY_TYPE.text}
    styleType={alertType}
    className='ContentAlert-Alert'
  >
    {text}
  </Alert>
);
